export default "__VITE_ASSET__BZSZo7Lf__"